export default "__VITE_ASSET__BHOiR3an__"